import Vue from 'vue'
import Router from 'vue-router'

import SilverHearts from '../components/app/SilverHearts'

import Main from '../components/app/Main'
import Index from '../components/app/Index'
import Diary from '../components/app/Diary'
import Diaries from '../components/app/Diaries'

import Login from '../components/admin/Login'
import Admin from '../components/admin/Admin'
import AdminDashboard from '../components/admin/Dashboard'
import AdminDiaryEdit from '../components/admin/DiaryEdit'
import AdminImages from '../components/admin/Images'
import AdminImageEdit from '../components/admin/ImageEdit'
import AdminWebsockets from '../components/admin/WebsocketView'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: '',
          component: AdminDashboard
        },
        {
          path: 'diary/:key',
          component: AdminDiaryEdit
        },
        {
          path: 'images',
          component: AdminImages
        },
        {
          path: 'images/:key',
          component: AdminImageEdit
        },
        {
          path: 'websockets',
          component: AdminWebsockets
        }
      ]
    },
    {
      path: '/auth',
      component: Login,
    },
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '',
          redirect: '/releases/silver-hearts'
        },
        {
          path: '/releases',
          redirect: '/releases/silver-hearts'
        },
        {
          path: '/releases/silver-hearts',
          component: SilverHearts,
          name: 'Silver Hearts',
        },
        {
          path: 'index',
          component: Index,
          name: 'index'
        },
        {
          path: 'diary',
          component: Diaries,
          name: 'Diaries'
        },
        {
          path: 'diary/:key',
          component: Diary,
          name: 'Diary'
        },
        {
          path: '*',
          redirect: '/'
        }
      ]
    }
  ]
})

export default router
